// Package imports
import { useLayoutEffect } from 'react';
import { useLocation } from 'react-router-dom';

type Props = {
  children: React.ReactNode;
};

const ScrollTopWrapper: React.FC<Props> = ({ children }: Props) => {
  const location = useLocation();

  useLayoutEffect(() => {
    document.documentElement.scrollTo(0, 0);
  }, [location.pathname]);
  return <>{children}</>;
};

export default ScrollTopWrapper;
